/* Rorilio · PDP Calzón Faja Sculpt 360°. Galerie, compte à rebours, packs (couleur + taille par pièce), ajout panier BOGO,
   guide des tailles, vidéos paresseuses, carrousel vidéo, boutons de retour à l'offre. Aucun effet hors des éléments sc-. */
(function () {
  if (window.__sculptPdp) return;
  window.__sculptPdp = true;

  const store = {
    get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* stockage indisponible */ } },
  };

  /* ---------- Galerie ---------- */
  function initGallery(root) {
    const track = root.querySelector('[data-sc-track]');
    if (!track) return;
    const slides = [...track.children];
    const thumbs = [...root.querySelectorAll('[data-sc-thumb]')];
    const dots = [...root.querySelectorAll('.sc-gallery__dots span')];
    const go = (i) => {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };
    const current = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    const mark = () => {
      const i = current();
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      const t = thumbs[i];
      if (t && t.parentElement) t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
    };
    let raf;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(mark); }, { passive: true });
    thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.scThumb))));
    const prev = root.querySelector('[data-sc-prev]');
    const next = root.querySelector('[data-sc-next]');
    if (prev) prev.addEventListener('click', () => go(current() - 1));
    if (next) next.addEventListener('click', () => go(current() + 1));
    root.scGo = (color) => {
      const c = String(color || '').toLowerCase();
      const i = slides.findIndex((s) => (s.dataset.alt || '').endsWith(' ' + c));
      if (i >= 0) go(i);
    };
  }

  const mexicoClock = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'America/Mexico_City', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  function secondsUntilMexicoMidnight() {
    const p = Object.fromEntries(mexicoClock.formatToParts(new Date()).map(x => [x.type, x.value]));
    return 86400 - (Number(p.hour) * 3600 + Number(p.minute) * 60 + Number(p.second));
  }
  /* Offre du jour : minuit à Mexico, identique pour tous les visiteurs. */
  function initTimer(el) {
    const h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
    const pad = n => String(n).padStart(2, '0');
    const tick = () => {
      const t = secondsUntilMexicoMidnight();
      h.textContent = pad(Math.floor(t / 3600));
      m.textContent = pad(Math.floor((t % 3600) / 60));
      s.textContent = pad(t % 60);
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Offre + ajout panier ---------- */
  function initOffer(main) {
    const offer = main.querySelector('[data-sc-offer]');
    const form = document.getElementById(main.dataset.formId);
    const atc = main.querySelector('[data-sc-atc]');
    const err = main.querySelector('[data-sc-err]');
    const status = main.querySelector('[data-sc-status]');
    const gallery = main.querySelector('[data-sc-gallery]');
    if (!offer) return;
    const packs = [...offer.querySelectorAll('[data-sc-pack]')];
    const active = () => packs.find((p) => p.querySelector('input[type=radio]').checked) || packs[0];

    const sync = () => {
      const a = active();
      packs.forEach((p) => {
        const on = p === a;
        p.classList.toggle('is-selected', on);
        const u = p.querySelector('[data-sc-units]');
        if (u) u.hidden = !on;
      });
      if (atc) {
        const ok = a && a.dataset.available !== 'false';
        const label = atc.querySelector('[data-sc-atc-label]');
        if (ok) atc.removeAttribute('aria-disabled'); else atc.setAttribute('aria-disabled', 'true');
        if (label) label.textContent = ok ? atc.dataset.label : atc.dataset.unavailable;
      }
    };
    packs.forEach((p) => p.querySelector('input[type=radio]').addEventListener('change', sync));

    // Pastilles couleur : une par pièce ; le libellé « Color: X » suit la première pièce ; la galerie montre la couleur choisie.
    offer.querySelectorAll('[data-sc-unit]').forEach((unit) => {
      const sw = [...unit.querySelectorAll('[data-color]')];
      const name = unit.querySelector('[data-sc-color-name]');
      const set = (b, move) => {
        sw.forEach((x) => { const on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
        if (name) name.textContent = b.dataset.color;
        if (move && gallery && gallery.scGo) gallery.scGo(b.dataset.color);
      };
      sw.forEach((b) => b.addEventListener('click', () => set(b, true)));
      const first = sw.find((x) => x.classList.contains('is-on')) || sw[0];
      if (first) set(first, false);
    });

    const cartDrawer = document.querySelector('cart-drawer');
    if (form) form.addEventListener('submit', async (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      const a = active();
      if (!a || a.dataset.available === 'false' || atc.getAttribute('aria-disabled') === 'true') return;
      const vEl = main.querySelector('[data-sc-variants]') || document.querySelector('[data-sc-variants]');
      const [ids, o1, o2, av] = (vEl ? vEl.textContent : '[]|[]|[]|[]').split('|').map((x) => JSON.parse(x));
      const picks = [...a.querySelectorAll('[data-sc-unit]')].map((u) => {
        const c = u.querySelector('.sc-swatch.is-on');
        const s = u.querySelector('[data-sc-size]');
        return { color: c ? c.dataset.color : '', size: s ? s.value : '' };
      });
      // Une ligne par variante (Color / Talla) ; même variante choisie deux fois = quantité 2. Les remises automatiques font le reste.
      const qty = new Map();
      for (const p of picks) {
        const i = ids.findIndex((_, k) => o1[k] === p.color && o2[k] === p.size);
        if (i < 0 || av[i] === false) { if (err) { err.textContent = p.color + ' / ' + p.size + ' : ' + (atc.dataset.unavailable || ''); err.hidden = false; } return; }
        qty.set(ids[i], (qty.get(ids[i]) || 0) + 1);
      }
      const body = { items: [...qty].map(([id, quantity]) => ({ id, quantity })) };
      if (cartDrawer && cartDrawer.getSectionsToRender) { body.sections = cartDrawer.getSectionsToRender().map((s) => s.id); body.sections_url = window.location.pathname; }
      atc.setAttribute('aria-disabled', 'true');
      atc.classList.add('loading');
      if (err) err.hidden = true;
      try {
        const r = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body),
        });
        const res = await r.json();
        if (!r.ok || res.status) throw new Error(res.description || res.message || r.status);
        if (status) status.textContent = picks.map((p) => p.color + ' / ' + p.size).join(', ');
        if (cartDrawer && cartDrawer.renderContents && res.sections) { cartDrawer.classList.remove('is-empty'); cartDrawer.renderContents(res); }
        else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      } catch (ex) {
        if (err) { err.textContent = String(ex.message || ex); err.hidden = false; }
      }
      atc.classList.remove('loading');
      atc.removeAttribute('aria-disabled');
    }, true);
    sync();
  }

  /* ---------- Guide des tailles ---------- */
  function initSize(modal) {
    const d = modal.dataset;
    const sizes = (d.chart || '').split(/\n/).map((l) => l.trim()).filter(Boolean).map((l) => {
      const p = l.split('|');
      return { label: p[0], us: p[1], cmin: +p[2], cmax: +p[3], imin: +p[4], imax: +p[5] };
    });
    const $ = (s) => modal.querySelector(s);
    const $$ = (s) => [...modal.querySelectorAll(s)];
    let calcUnit = d.defaultUnit || 'cm', chartUnit = d.defaultUnit || 'cm';
    const open = () => { modal.hidden = false; document.body.style.overflow = 'hidden'; const i = $('[data-sc-sz-waist]'); if (i) setTimeout(() => i.focus(), 50); };
    const close = () => { modal.hidden = true; document.body.style.overflow = ''; };
    document.querySelectorAll('[data-sc-sz-open]').forEach((b) => b.addEventListener('click', open));
    modal.addEventListener('click', (e) => { if (e.target === modal || e.target.closest('[data-sc-sz-close]')) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) close(); });
    $$('[data-sc-sz-tab]').forEach((t) => t.addEventListener('click', () => {
      $$('[data-sc-sz-tab]').forEach((x) => x.classList.toggle('is-active', x === t));
      $$('[data-sc-sz-pane]').forEach((p) => { p.hidden = p.dataset.scSzPane !== t.dataset.scSzTab; });
    }));
    const range = (s) => (chartUnit === 'cm' ? s.cmin + '-' + s.cmax + ' cm' : (s.imin === s.imax ? s.imin : s.imin + '-' + s.imax) + ' pulg');
    const table = () => {
      $('[data-sc-sz-table]').innerHTML = '<table class="sc-sz__table"><thead><tr><th>' + d.colSize + '</th><th>' + d.colUs + '</th><th>' + d.colWaist + '</th></tr></thead><tbody>' +
        sizes.map((s) => '<tr><td>' + s.label + '</td><td>' + s.us + '</td><td>' + range(s) + '</td></tr>').join('') + '</tbody></table>';
    };
    $$('[data-sc-sz-units]').forEach((g) => {
      const which = g.dataset.scSzUnits;
      const btns = [...g.querySelectorAll('[data-u]')];
      const mark = (u) => btns.forEach((b) => b.classList.toggle('is-active', b.dataset.u === u));
      mark(which === 'calc' ? calcUnit : chartUnit);
      btns.forEach((b) => b.addEventListener('click', () => {
        mark(b.dataset.u);
        if (which === 'calc') { calcUnit = b.dataset.u; $('[data-sc-sz-suffix]').textContent = calcUnit === 'cm' ? 'cm' : 'pulg'; }
        else { chartUnit = b.dataset.u; table(); }
      }));
    });
    $('[data-sc-sz-suffix]').textContent = calcUnit === 'cm' ? 'cm' : 'pulg';
    table();
    // Mesure en cm ; à la frontière ou entre deux lignes, on arrondit à la taille supérieure (comme la source).
    const recommend = (cm) => {
      const first = sizes[0], last = sizes[sizes.length - 1];
      if (cm < first.cmin) return { size: first, st: 'below' };
      if (cm > last.cmax) return { size: last, st: 'above' };
      let m = null;
      sizes.forEach((s) => { if (cm >= s.cmin && cm <= s.cmax) m = s; });
      if (m) return { size: m, st: 'exact' };
      return { size: sizes.find((s) => s.cmin > cm) || last, st: 'between' };
    };
    const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const calc = () => {
      const er = $('[data-sc-sz-err]'), res = $('[data-sc-sz-res]');
      er.hidden = true; res.hidden = true;
      const v = parseFloat(String($('[data-sc-sz-waist]').value || '').trim().replace(',', '.'));
      if (isNaN(v) || v <= 0) { er.textContent = d.msgEmpty; er.hidden = false; return; }
      const cm = calcUnit === 'cm' ? v : v * 2.54;
      if (cm < 45 || cm > 180) { er.textContent = d.msgOff; er.hidden = false; return; }
      const r = recommend(Math.round(cm));
      const msg = { above: d.msgAbove, below: d.msgBelow, between: d.msgBetween, exact: d.msgExact }[r.st] || '';
      res.innerHTML = '<p class="lbl">' + esc(d.msgRec) + '</p><div class="sz">' + esc(r.size.label) + '</div><p class="us">' + esc(d.colUs) + ' ' + esc(r.size.us) + '</p><p class="note">' +
        esc(msg.replace('[talla]', r.size.label)) + '</p>' + (d.msgGuar ? '<p class="guar">✓ ' + esc(d.msgGuar) + '</p>' : '');
      res.hidden = false;
    };
    $('[data-sc-sz-calc]').addEventListener('click', calc);
    $('[data-sc-sz-waist]').addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); calc(); } });
    $$('[data-sc-sz-go]').forEach((b) => b.addEventListener('click', () => { close(); toOffer(); }));
  }

  /* ---------- Retour à l'offre ---------- */
  function toOffer() {
    const o = document.getElementById('sc-offer');
    if (!o) return false;
    window.scrollTo({ top: o.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
    return true;
  }
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-sc-scroll]');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    if (href === '#sc-offer' || href === '') { if (toOffer()) e.preventDefault(); }
  });

  /* ---------- Vidéos : chargées et lues seulement à l'écran ---------- */
  function initVideos() {
    const vids = [...document.querySelectorAll('[data-sc-video]')];
    const load = (v) => { if (!v.src && v.dataset.src) { v.src = v.dataset.src; v.load(); } };
    if (!('IntersectionObserver' in window)) { vids.forEach((v) => { load(v); v.play().catch(() => {}); }); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      const v = en.target;
      if (en.isIntersecting) { load(v); const p = v.play(); if (p && p.catch) p.catch(() => {}); } else if (!v.paused) v.pause();
    }), { rootMargin: '200px 0px', threshold: 0.15 });
    vids.forEach((v) => io.observe(v));
  }

  /* ---------- Carrousel vidéos ---------- */
  function initUgc(root) {
    const track = root.querySelector('[data-sc-ugc-track]');
    if (!track) return;
    const n = track.children.length;
    const dots = [...root.querySelectorAll('[data-sc-ugc-dot]')];
    let i = 0;
    const go = (k) => {
      i = (k + n) % n;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      dots.forEach((d, j) => d.classList.toggle('is-active', j === i));
    };
    const p = root.querySelector('[data-sc-ugc-prev]'), nx = root.querySelector('[data-sc-ugc-next]');
    if (p) p.addEventListener('click', () => go(i - 1));
    if (nx) nx.addEventListener('click', () => go(i + 1));
    dots.forEach((d) => d.addEventListener('click', () => go(Number(d.dataset.scUgcDot))));
    let x0 = null;
    track.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
  }

  /* ---------- Carrousel d'avis (points + glissement) ---------- */
  function initRv(root) {
    const track = root.querySelector('[data-sc-rv-track]');
    const dots = [...root.querySelectorAll('[data-sc-rv-dot]')];
    if (!track || dots.length < 2) return;
    let i = 0;
    const go = (k) => { i = (k + dots.length) % dots.length; track.style.transform = 'translateX(' + (-100 * i) + '%)'; dots.forEach((d, j) => d.classList.toggle('is-active', j === i)); };
    dots.forEach((d) => d.addEventListener('click', () => go(Number(d.dataset.scRvDot))));
    let x0 = null;
    track.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', (e) => { if (x0 === null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1)); x0 = null; });
  }

  /* ---------- Cuerpos reales : 2 rangées en boucle, sens opposés, pause au survol/toucher ---------- */
  function initRb(root) {
    const speed = (Number(root.dataset.speed) || 0) / 10;
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!speed || reduce) return;
    root.querySelectorAll('[data-sc-rb-row]').forEach((track) => {
      const dir = Number(track.dataset.dir) || 1;
      const originals = [...track.children];
      if (!originals.length) return;
      originals.forEach((c) => { const k = c.cloneNode(true); k.removeAttribute('data-shopify-editor-block'); k.setAttribute('aria-hidden', 'true'); track.appendChild(k); });
      let reset = 0, acc = 0, paused = false;
      const measure = () => { reset = track.children[originals.length].offsetLeft - originals[0].offsetLeft; if (dir < 0 && track.scrollLeft < 1) track.scrollLeft = reset; };
      measure();
      window.addEventListener('resize', measure);
      ['mouseenter', 'touchstart'].forEach((e) => track.addEventListener(e, () => { paused = true; }, { passive: true }));
      ['mouseleave', 'touchend'].forEach((e) => track.addEventListener(e, () => { setTimeout(() => { paused = false; }, e === 'touchend' ? 1500 : 0); }, { passive: true }));
      const tick = () => {
        if (!paused && reset > 0) {
          acc += speed;
          const whole = Math.floor(acc);
          if (whole >= 1) {
            acc -= whole;
            track.scrollLeft += dir * whole;
            if (track.scrollLeft >= reset) track.scrollLeft -= reset; else if (track.scrollLeft <= 0) track.scrollLeft += reset;
          }
        }
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  }

  function init() {
    document.querySelectorAll('[data-sc-main]').forEach((m) => { initGallery(m.querySelector('[data-sc-gallery]') || m); initOffer(m); });
    document.querySelectorAll('[data-sc-timer]').forEach(initTimer);
    document.querySelectorAll('[data-sc-sz]').forEach(initSize);
    document.querySelectorAll('[data-sc-ugc]').forEach(initUgc);
    document.querySelectorAll('[data-sc-rv]').forEach(initRv);
    document.querySelectorAll('[data-sc-rb]').forEach(initRb);
    initVideos();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
